export default __webpack_public_path__ + "static/thinFont-917b68a7145a64f2b07fed9c939219f2.woff2";